import { Avatar } from "antd";
import React from "react";
import { ReactElement } from "react";

const SingleService = ({
  ServiceDetails,
}: {
  ServiceDetails: any;
}): ReactElement => {
  return (
    <>
      <div className="">
        <div className="flex flex-no-wrap py-2">
          <div className="w-2/5 flex-none">
            <div className="text-gray-500">
              <span className="font-bold">Type</span>
            </div>
          </div>
          <div className="w-2/5 flex-none">
            <div className="text-gray-700">
              <span>
                <Avatar
                  size={40}
                  src={ServiceDetails?.logo}
                  style={{
                    background: ServiceDetails?.backgroundColor,
                    padding: 10,
                    marginRight: 5,
                  }}
                />{" "}
                {ServiceDetails?.name}
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-no-wrap py-2">
          <div className="w-2/5 flex-none">
            <div className="text-gray-500">
              <span className="font-bold">Description</span>
            </div>
          </div>
          <div className="w-2/5 flex-none">
            <div className="text-gray-700">
              <span>{ServiceDetails?.description}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleService;
